// extracted by mini-css-extract-plugin
module.exports = {"root":"_3s4dAvcAFVwMlI5SciqAg2"};